module.exports = __webpack_public_path__ + "489a62dfa60c5f2af25b5e13a4c81d80.jpg";